class AureyMobileMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.categories = this.querySelector('[data-aurey-mobile-categories]');
    this.querySelectorAll('[data-aurey-mobile-open]').forEach((button) => button.addEventListener('click', () => this.open(button.dataset.aureyMobileOpen)));
    this.querySelectorAll('[data-aurey-mobile-back]').forEach((button) => button.addEventListener('click', () => this.back()));
    this.querySelectorAll('[data-aurey-mobile-close]').forEach((button) => button.addEventListener('click', () => this.closeDrawer()));
  }

  open(index) {
    this.categories.hidden = true;
    this.querySelectorAll('[data-aurey-mobile-panel]').forEach((panel) => { panel.hidden = panel.dataset.aureyMobilePanel !== index; });
    this.closest('.menu-drawer__inner-submenu')?.classList.add('aurey-mobile-category-open');
    this.scrollTo({ top: 0, behavior: 'auto' });
  }

  back() {
    this.categories.hidden = false;
    this.querySelectorAll('[data-aurey-mobile-panel]').forEach((panel) => { panel.hidden = true; });
    this.closest('.menu-drawer__inner-submenu')?.classList.remove('aurey-mobile-category-open');
  }

  closeDrawer() {
    this.back();
    document.querySelector('#Details-menu-drawer-container > .menu-drawer .menu-drawer__close-button')?.click();
  }
}

if (!customElements.get('aurey-mobile-menu')) customElements.define('aurey-mobile-menu', AureyMobileMenu);
